import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import colors from 'app/styles/common/colors.module.scss';

import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { Noop, WithTestId } from 'types/app';

import { Icons } from '@Atomic/atoms/Icons';
import { Text } from '@Atomic/atoms/Text';

import styles from './courierDeliveryBanner.module.scss';

type CourierDeliveryBannerProps = {
  onClick: Noop;
};

export const CourierDeliveryBanner: FC<WithTestId<CourierDeliveryBannerProps>> = ({
  testId,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.deliveryCard}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onClick}
      data-testid={getTestIdByParts(testId, 'courier')}
    >
      <Text className={styles.deliveryText}>{t('offer.deliveryText')}</Text>
      <div className={styles.icon}>
        <Icons.ChevronRight width={16} height={16} color={colors.primaryCrimson} />
      </div>
    </div>
  );
};
